/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop } from 'vue-property-decorator'
import { NewReviewModule } from '@/store/modules/newReview'
import { getUserList,getFileByFunctionsId, setReview, getEditFileByFunctionsId } from '@/api/common'

@Component({
})
export default class NodeWrap extends Vue {
    approvalPersonObject = {
        approvalPersonType: 0,
        approvalPerson: [],
        approvalType: 1,
        editFile: '',
    }
    conditionObject = {
        conditionFile: '',
        selectCondition: '',
        conditionFileValue: '',
    }
    userList: any[] = []
    conditionFileList: any = [] // 可选择的条件字段列表
    editFileList: any = [] // 选择编辑字段的列表
    isPreservation = false
    disabledBtn = false // 保存按钮禁用

    // ------ prop ------
    @Prop() nodeWrap!: any
    @Prop() functionsId!: number
    @Prop() nodeRelevant!: any

    // ------ 生命周期 ------
    created() {
        this.getUserList()
        this.getFileByFunctionsId()
        this.getEditFileByFunctionsId()
    }

    // ------ 方法 ------
    async getUserList() {
        const data: any = await getUserList()
        this.userList = data
    }
    async getFileByFunctionsId() {
        const data: any = await getFileByFunctionsId({ functionsId: this.functionsId })
        this.conditionFileList = data.fileList
    }
    async getEditFileByFunctionsId() {
        const data = await getEditFileByFunctionsId(this.functionsId) as unknown as { functionsEditFileList: { enFile: string; zhFile: string }[] }
        this.editFileList = data.functionsEditFileList
    }
    approvalPersonTypeChange() {
        this.approvalPersonObject.approvalPerson = []
    }
    approvalTypeChange() {
        if(this.approvalPersonObject.approvalPerson.length > 1) {
            this.$message.error('您已选择审批人超过一个，最多选择一个，请删除后重试。')
            this.approvalPersonObject.approvalType = 0
        }
    }
    back() {
        NewReviewModule.setStepsAvtive(0)
    }
    async preservation() {
        const obj = JSON.parse(JSON.stringify(this.nodeWrap))
        const bol = await this.verificationNode(obj)
        if(bol) {
            this.setReview()
        }else{
            this.$message.error('请将审批流配置信息补充完整！')
        }
    }

    // 保存审批流
    async setReview() {

        const obj = JSON.parse(JSON.stringify(this.nodeWrap))
        this.nodeWrap = JSON.parse(JSON.stringify(obj))
        this.$emit('update:nodeWrap', this.nodeWrap)
        const { name, type, action, detail,isDelete, departmentList, userList } = this.nodeRelevant
        const newobj = {
            name,
            functionsLevel1Id: type,
            functionsLevel2Id: action,
            isDelete,
            detail,
            departmentIdList: departmentList,
            userIdList: userList,
            nodeObject: this.nodeWrap
        }
        if(this.$route.query.id) {
            newobj['id'] = Number(this.$route.query.id)
        }
        this.disabledBtn = true
        setReview(newobj).then(() => {
            this.$message.success(this.$route.query.id ? '修改审批流成功' : '新建审批流成功')
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch(() => {
            this.disabledBtn = false
        })

    }

    async verificationNode(item: any) {
        let bol = true
        // const p = new Promise((res, rej) => (res('验证通过')))
        if(item.types === '0') {
            if(!item.approvalType) {
                this.$message.error('请将审批流配置信息填写完整')
                item.infoNode = 1
                bol = false;
                return false;
            }
            if(item.approvalType === '0') {
                if(item.approvalPersonOrLevelType === '1') {
                    if(item.approvalPersonOrLevelRange === '0') {
                        if(item.userIdList.length === 0) {
                            this.$message.error('请将审批流配置信息填写完整')
                            item.infoNode = 1
                            bol = false;
                            return false
                        }
                    }
                }

            } else {
                if(!item.approvalPersonOrLevelRange) {
                    this.$message.error('请将审批流配置信息填写完整')
                    item.infoNode = 1
                    bol = false;
                    return false
                }
            }
            if(!item.approvalSettingType) {
                this.$message.error('请将审批流配置信息填写完整')
                item.infoNode = 1
                bol = false;
                return false
            } else {
                if(item.approvalSettingType === '1') {
                    if(!item.approvalSettingUserId) {
                        this.$message.error('请将审批流配置信息填写完整')
                        item.infoNode = 1
                        bol = false;
                        return false
                    }
                }
            }
        }

        if(item.types === '1') {
            item.infoNode = 0
            if(!item.approvalType) {
                this.$message.error('请将抄送人的信息填写完整')
                item.infoNode = 1
                bol = false;
                return false
            }
            if(item.approvalType === '0') {
                if(item.approvalPersonOrLevelRange == '0') {
                    if(item.userIdList.length === 0) {
                        this.$message.error('请将抄送人的信息填写完整')
                        item.infoNode = 1
                        bol = false;
                        return false
                    }
                } else {
                    if(item.approvalPersonOrLevelRange !== '1') {
                        this.$message.error('请将抄送人的信息填写完整')
                        item.infoNode = 1
                        bol = false;
                        return false
                    }
                }
            } else {
                if(!item.approvalPersonOrLevelRange) {
                    this.$message.error('请将抄送人的信息填写完整')
                    item.infoNode = 1
                    bol = false;

                    return false
                }
            }
        }

        if(item.types === '2') {
            if(JSON.stringify(item.nodeObject) === '{}' && JSON.stringify(item.conditionList) === '[]') {
                this.$message.error('审批流结构不完善')
                bol = false;
                return false
            }
        }

        if (JSON.stringify(item.nodeObject) === '{}' && JSON.stringify(item.conditionList) === '[]') {
            bol = true
        } else {
            if (JSON.stringify(item.nodeObject) !== '{}') {
                bol = await this.verificationNode(item.nodeObject)
                if (bol == false) {
                    return false;
                }
            }
            if (JSON.stringify(item.conditionList) !== '[]') {
                bol = await this.verificationConditions(item.conditionList)
                if(bol == false){
                    return false;
                }
            }
        }
        return bol
    }
    verificationConditions(conditions: any[]) {
        let bol = true
        bol = conditions.every(item => {
            if(item.priority !== 0 && !item.priority) {
                item.infoNode = 1
                return false
            } else if(item.priority !== 0) {
              if(!item.condition || !item.conditionCnFile || !item.conditionCnValue || !item.conditionFile || !item.conditionValue || item.conditionValue.length === 0) {
                item.infoNode = 1
                return false
              } else {
                  return true
              }
            } else {
                if(JSON.stringify(item.nodeObject) !== '{}') {
                    return this.verificationNode(item.nodeObject)
                }
                if(JSON.stringify(item.conditionList) !== '[]') {
                    return this.verificationConditions(item.conditionList)
                }
                if(JSON.stringify(item.nodeObject) === '{}' && JSON.stringify(item.conditionList) === '[]') {
                    return true
                } else {
                    return true
                }
            }


        })
        return bol
    }
}
